<template>
  <div class="studies_bg">
    <TestPortalBanner v-if="isTestPortal" :shouldHideActionButtons="shouldHideActionButtons"/>
    <div class="container container-style">
      <div class="row">
        <div class="col-xs-12 col-md-12 col-lg-12 col-sm-12" v-if="showErrorMsg">
          <p class="fs-24 text-center text-danger">{{ errorMsg }}</p>
        </div>
        <div class="col-xs-12 col-md-12 col-lg-12 col-sm-12" v-else>
          <p class="fs-24 text-center color_ff">
            Report data export file downloaded successfully
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TestPortalBanner from "@/components/common/test-portal-banner";

export default {
  name: "download-report-data-export",
  data() {
    return {
      showErrorMsg: false,
      errorMsg: null
    };
  },
  props: ["isTestPortal", "shouldHideActionButtons"],
  components: {
    TestPortalBanner
  },
  mounted() {
    const { resourceId } = this.$route.params;
    this.$api.downloadReportDataZip(resourceId).then(
      response => {
        if (response.body && response.body.data && response.body.data !== "") {
          window.open(response.body.data, "_self");
        } else {
          this.showErrorMsg = true;
          this.errorMsg = "No response from the server";
        }
      },
      error => {
        this.showErrorMsg = true;
        this.errorMsg = error.body && error.body.message ? error.body.message : "Error while downloading the file";
      }
    );
  }
};
</script>
<style>
.studies_bg {
  background: #34537d url("/static/img/bg/login_bg.png") no-repeat fixed center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 100%;
  min-height: 100vh;
  background-blend-mode: soft-light;
}

.container-style {
  padding-top: 120px;
}

@media (max-width: 1023px) {
  body {
    width: auto;
    min-width: auto;
  }
}
</style>
